"use strict";
/**
 * Authentication-related type definitions
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=auth.js.map